import axios from 'axios';
import * as vars from './vars';

export function validateSessionToken(jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/authentication/ValidateSessionToken`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
    })
}


export function authenticateUser(credentials) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/untrusted/authentication/AuthenticateLogin`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: credentials
    })
}

export function authenticateUserWithAuthToken(uid, authToken) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/authentication/ValidateSingleUserAuthentication',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {uid: uid, authToken: authToken}
    })
}

export function registerBasicUser(user) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/authentication/RegisterNewUser',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: user
    })
}

export function startCredentialRecovery(email) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/authentication/StartCredentialRecovery',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {
            email: email
        }
    })
}

export function validateAccountRecoveryCode(email, code) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/authentication/ValidateAccountRecoveryCode',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {
            email: email,
            code: code,
        }
    })
}

export function createNewAccountPassword(email, password) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/untrusted/authentication/CreateNewAccountPassword',
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken},
        data: {
            email: email,
            password: password,
        }
    })
}